var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_454_4200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.488282 2.31985V4.77058L-14.3867 4.77058C-14.8697 4.77058 -15.2617 5.09652 -15.2617 5.49975C-15.2617 5.90297 -14.8697 6.22891 -14.3867 6.22891L0.488282 6.22891V8.67964C0.488282 9.18641 1.23378 9.44089 1.66953 9.08214L5.53528 5.90225C5.80566 5.67985 5.80566 5.31964 5.53528 5.09725L1.66953 1.91735C1.23378 1.5586 0.488282 1.81308 0.488282 2.31985Z",
    fill: "#1C2B48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_454_4200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 5,
    fill: "white",
    transform: "matrix(0 -1 1 0 0.738281 10.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSolid);
export default __webpack_public_path__ + "static/media/arrowSolid.cd521c88.svg";
export { ForwardRef as ReactComponent };